<div class="container container--mobile-padding">
	<section class="main-work" [class.show]="sliderImages && sliderImages.length>0">
		<div class="main-work__slider" *ngIf="sliderImages && sliderImages.length>0">
			<image-slider [imagesList]="sliderImages"></image-slider>
			<!-- <tile-item [dataItem]="workData" [noUrlItem]="true" [visibleVideo]="true"></tile-item> -->
			<!-- <works-slider *ngIf="mastHeads.length>1" [mastHeads]="mastHeads"></works-slider> -->
		</div>
	</section>
</div>
<div class="container container--mobile-padding-more work-page">
	<div *ngIf="workData">
		<i class="title-italic work-page__brands" *ngIf="workData.brands && workData.brands.length">
			<ng-container *ngFor="let brand of workData.brands;index as i">
				{{brand.brand_name}}<ng-container *ngIf="i+1 != workData.brands.length">,</ng-container>
			</ng-container>
		</i>
		<h1 class="work-page__title">
			{{workData.name}}
		</h1>
		<p class="work-page__text" [innerHTML]="workData.description"></p>

		<ng-container *ngIf="workData.bounties && workData.bounties.length">
			<h2>{{ "WORK.AWARDS" | translate }}</h2>
			<div class="work-page__awards awards-list">
				<div class="awards-list__item" *ngFor="let award of workData.bounties">
					<div class="awards-list__img">
						<img [src]="baseUrl + award.logo" alt="{{award.bounty_name}}" title="{{award.bounty_name}}">
					</div>
					<p>{{award.quantity}}</p>
				</div>
			</div>
		</ng-container>
		<!--<ng-container *ngIf="workData.teams && workData.teams.length">
			<h2>{{ "WORK.TEAMS" | translate }}</h2>
			<div class="teams-list work-page__teams">
				<div class="teams-list__item" *ngFor="let person of workData.teams">
					<a [routerLink]="['/'+currentLang,'people',person.id]">{{person.name}}</a>
					<ng-container *ngIf="person.position && person.position.length"> - {{person.position}}</ng-container>

				</div>
			</div>
		</ng-container>-->

		<ng-container *ngIf="workData.mentions">
			<ng-container *ngIf="workData.mentions && workData.mentions.length">
				<h2 class="h2--mass-media">Публикации в СМИ</h2>
				<ng-container *ngFor="let mention of workData.mentions">
					<a class="mass-media" href="{{mention.link}}" target="_blank">
						<div class="mass-media__image" [style.backgroundImage]="'url('+ baseUrl + mention.image +')'"></div>
						<div class="mass-media__info">
							<div class="mass-media__name">
								<img *ngIf="mention.logo" [src]="baseUrl + mention.logo" alt="" title="">
							</div>
							<div class="mass-media__description">
								{{mention.title}}
							</div>
						</div>
					</a>
				</ng-container>
			</ng-container>
		</ng-container>

		<ng-container *ngIf="workData.otherTags && workData.otherTags.length">
			<h2 class="gray-title gray-title--small uppercase text-center ">{{ "WORK.TAGS" | translate }}</h2>
			<div class="tags-list">
				{{currentLang}}
				<ng-container *ngFor="let tag of workData.otherTags;let last = last">

					<a [routerLink]="['/'+currentLang,'tag',tag.team_slug]">{{tag.team_name}}</a>
					<ng-container *ngIf="!last">, </ng-container>
				</ng-container>
			</div>
		</ng-container>

	</div>
</div>
<div class="container container--mobile-padding work-page" *ngIf="similarWorkData && similarWorkData.length">
	<div>
		<h2 class="work-page__related-title gray-title text-center">{{ "WORK.UPNEXT" | translate }}</h2>
		<two-column-tile [dataItems]="similarWorkData" [srcUrl]="'/'+currentLang+'/work'"></two-column-tile>
	</div>
</div>
